






import { Vue, Component, Prop } from "@/shared/vuepack";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

@Component({
  components: {
    GenericLoadingSpinner,
    AccountHolderDashboard: () => import("./AccountHolderDashboard.vue"),
    AccountHolderDashboardV2: () => import("./v2/AccountHolderDashboard.vue")
  }
})
export default class AccountHolderDashboardDecider extends Vue {
  featureFlagStore = useFeatureFlagStore();

  @Prop ()
  username: string;

  @Prop ()
  partnerId: number;

  @Prop ()
  routeToContributions: Location;

  get isFeatureFlagReady () {
    return this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.featureFlagsAvailable;
  }

  get showV2 () {
    return this.featureFlagStore.flags.bend22847EnableV2AccountHolderDashboard;
  }
}
